import { css } from "@emotion/react";

export const bannerImage = css`
  width: 100%;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  height: calc(100vh - 18rem);
  min-height: 100%;
`;

export const centeredContentContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: calc(100vh - 18rem);
`;

export const panelPlaceholder = css`
  width: 100%;
  height: 100%;
`;
